import React, { useState, useEffect } from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {closeDrawer} from '../../actions/drawerActions';
import {retireQuestionnaire} from "../../actions/questionnaireTemplateActions";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import ArgoToolbarHook from "../common/ArgoToolbarHook";
import ArgoTextFieldHook from "../common/ArgoTextFieldHook";
import * as TEMPLATE from "../../constants/templateConstants";


// Questionnaires published with a future date can be retired, or questionnaires past their published end date (InActive = true)
const QuestionnaireRetireInActiveDrawer = (props) => {
    // State management using useState hooks
    const [notes, setNotes] = useState("");
    const [errorMessage, setErrorMessage] = useState("Retire note required.");
    const [toolbarErrorText, setToolbarErrorText] = useState("Retire note required.");

    // Function to check for validation errors on the page
    const checkForErrorsOnPage = () => {
        // Remove spaces to ensure there is a note, RETIRE Button will be disabled until there are no errors on the page
        let errorMsg = " ";
        if (notes.trim().length <= 0) {
            errorMsg = "Retire note required.";
        }
        setErrorMessage(errorMsg);
        setToolbarErrorText(errorMsg);
    };

    // Effect hook to run validation on component mount and when notes change
    useEffect(() => {
        checkForErrorsOnPage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notes]); // Re-run validation when notes change

    // Handle toolbar button clicks (RETIRE/CANCEL)
    const handleToolbarButtonClick = (event, fieldName, buttonTitle) => {
        switch (buttonTitle) {
            case "RETIRE":
                props.retireQuestionnaire(props.questionnaireRow.id, {notes: notes}, props.questionnaireRow.templateKey, props.filter, props.versionsFilter);
                break;
            case "CANCEL":
                props.closeDrawer();
                break;
            // no default
        }
    };

    // Handle text input changes
    const onTextChange = (event, fieldName) => {
        setNotes(event.target.value);
        // Validation will run automatically via useEffect dependency on notes
    };

    return (
        <div>
            <ArgoAppBarHook
                title={"Retire:"}
                titleFor={props.retireDrawerTemplate.name}
                qualifierFor={props.retireDrawerTemplate.nameQualifier}
                showMenuIconButton={false}
                noIcon={true}
                isDrawer={true}
                width={questionnaireRetireInActiveDrawerProps.width}
            />

            <div style={{height: '64px'}}></div>

            <ArgoToolbarHook
                fileName="QuestionnaireRetireInActiveDrawer"
                fieldName="retire-or-cancel"
                buttonTitles={["RETIRE", "CANCEL"]}
                onClick={handleToolbarButtonClick}
                leftButtonDisabled={errorMessage !== " "}
                toolbarErrorText={toolbarErrorText}
                width={questionnaireRetireInActiveDrawerProps.width}
            />

            <div id="QuestionnaireRetireInActiveDrawer-page-div"
                 style={{paddingLeft: "20px", paddingRight: "20px", marginTop: "30px"}}>

                <div style={{height: "30px"}}>&nbsp;</div>

                <ArgoTextFieldHook
                    fileName="QuestionnaireRetireInActiveDrawer"
                    fieldName="notes"
                    label="Note"
                    value={notes}
                    multiline={true}
                    autoFocus={true}
                    onChange={onTextChange}
                    errorText={errorMessage}
                />
            </div>

        </div>
    );
};

function mapDispatchToProps(dispatch) {
    return {
        closeDrawer: bindActionCreators(closeDrawer, dispatch),
        retireQuestionnaire: bindActionCreators(retireQuestionnaire, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        retireDrawerTemplate: state.openCloseSecondaryDrawer.template,
        filter: state.filter["questionnaires"],
        versionsFilter: state.filter[TEMPLATE.FILTER.versions.questionnaire]
    };
}

const questionnaireRetireInActiveDrawerProps = {
    opensecondary: true,
    width: "55%",
    docked: false,
    anchor: "right"
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireRetireInActiveDrawer);
export {questionnaireRetireInActiveDrawerProps};
